module.exports = __webpack_public_path__ + "img/desc2.dd5077ae.jpg";